<template>
    <div class="row">
        <div class="col-md-12">
            <h1 class="h4 mb-3 text-gray-800">
                {{ $t("Editar Histórico de Acolhimento") }}
            </h1>
        </div>
        <load v-if="loading" />
        <div v-else class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <header-familia v-if="item.familia" :item="item.familia" />
                </div>
            </div>
            <!--Tabela-->
            <div class="row">
                <sidebar-servicos active="acolhimentos" />
                <div class="col-md-9">
                    <b-card
                        class="shadow h-100"
                        v-if="historicoStatus == false"
                    >
                        <template v-slot:default>
                            <form @submit.prevent="submit" ref="addItem">
                                <div class="row">
                                    <form-select
                                        v-model="item.pessoas"
                                        :multiple="true"
                                        label="Usuário(s)"
                                        :itens="pessoas"
                                        :required="true"
                                        :disabled="true"
                                        grid="12"
                                    />

                                    <form-select
                                        v-if="!loadOutra"
                                        v-model="item.unidade_acolhedora_id"
                                        label="Selecione a Unidade Acolhedora"
                                        grid="12"
                                        :itens="unidades"
                                        :required="true"
                                        ajuda="Se a Unidade Acolhedora não for encontrada na lista você pode marcar a opção abaixo (Outra Unidade?) e digitar o nome da Unidade Acolhedora"
                                    />

                                    <form-toggle
                                        grid="12"
                                        mt="0"
                                        v-model="loadOutra"
                                        label="Outra Unidade?"
                                    />

                                    <form-input
                                        v-model="item.outra_unidade"
                                        label="Digite o nome da Unidade Acolhedora"
                                        grid="12"
                                        v-if="loadOutra"
                                        :required="true"
                                    />

                                    <form-calendar
                                        v-model="item.data_inicial"
                                        grid="6"
                                        label="Data de Início"
                                        :required="true"
                                    />
                                    <form-calendar
                                        v-model="item.data_final"
                                        grid="6"
                                        label="Data Final"
                                    />

                                    <form-textarea-editor
                                        v-model="item.detalhes"
                                        grid="12"
                                        label="Detalhes do Acolhimento"
                                        :required="true"
                                    />

                                    <form-select
                                        @change="verificarStatus"
                                        v-model="item.status"
                                        label="Status"
                                        grid="3"
                                        :itens="$root.arrays.status_acolhimento"
                                    />

                                    <form-file
                                        @submit="submitFile"
                                        multiple
                                        btn-text="Iniciar"
                                        :progress="progressCompleted"
                                        grid="9"
                                    />
                                </div>
                                <div
                                    class="row pt-4 px-0 d-flex justify-content-end"
                                >
                                    <div class="col-auto px-2 text-right">
                                        <a
                                            class="router-link-exact-active active px-3"
                                            @click="historicoStatus = true"
                                        >
                                            <i class="fas fa-history"></i>
                                            Histórico de Status
                                        </a>
                                        <router-link
                                            :to="
                                                '/dashboard/familia/acolhimentos/' +
                                                item.familia_id +
                                                '?familia_id=' +
                                                item.familia_id
                                            "
                                            class="btn btn-default"
                                        >
                                            <i class="mdi mdi-arrow-left" />
                                        </router-link>

                                        <a
                                            class="btn btn-primary"
                                            @click="$bvModal.show('modal-auditoria')"
                                            :title="$t('Auditoria')"
                                            v-b-tooltip.hover
                                        >
                                            <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                                        </a>

                                        <a
                                            v-if="
                                            $store.state.user.role_details.name == 'Admin' ||
                                            $store.state.user.role_details.name == 'Gestor(a)' ||
                                            $store.state.user.id == item.user_id
                                            "
                                            title="Remanejar"
                                            class="btn btn-warning py-2"
                                            @click="$bvModal.show('modal-remanejar-servico')"
                                        >
                                            <i class="fas fa-exchange-alt mdi-18px" />
                                            {{ $t("Remanejar") }}
                                        </a>

                                        <b-button
                                            :title="$t('Visualizar e Imprimir')"
                                            :to="
                                                '/dashboard/familia/acolhimentos/show/' +
                                                item.id
                                            "
                                            class="py-1"
                                            size="sm"
                                            type="button"
                                            v-b-tooltip.hover
                                            variant="primary"
                                        >
                                            <i
                                                class="mdi mdi-printer mdi-18px"
                                            />
                                        </b-button>

                                        <button
                                            class="btn btn-success btn-submit"
                                            data-style="zoom-in"
                                            type="submit"
                                        >
                                            <i class="mdi mdi-content-save" />
                                            {{ $t("Salvar") }}
                                        </button>
                                    </div>
                                </div>
                            </form>

                            <div v-if="item.anexos">
                                <anexos :anexos="item.anexos" />
                            </div>
                        </template>
                    </b-card>

                    <div class="card mb-0 shadow card-body" v-else>
                        <div class="tab-content">
                            <div class="animate__animated animate__fadeIn">
                                <div class="row">
                                    <div class="col-12">
                                        <h4 class="font-weight-bold">
                                            Histórico de Acolhimento
                                        </h4>
                                    </div>
                                    <HistoricoStatus
                                        @voltar="historicoStatus = false"
                                        :id="item.id"
                                        :familia="item.familia_id"
                                        :status="status_item"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <status-historico
                        :model="model"
                        :modulo="model"
                        titulo_modulo="HISTÓRICO DE ACOLHIMENTO"
                        :id="item.id"
                        :status-anterior="statusAnterior"
                        :status-atual="statusAtual"
                        :status="status_item"
                        @submit="submit"
                        @reload="getItem"
                        @historico="historicoStatus = true"
                    />
                </div>
            </div>
        </div>
        <ModalRemanejarServico
            servico="acolhimentos"
            :servico_id="item.id"
            :tecnico_id="item.user.tecnico.id"
        />
        <ModalAuditoria
            servico="familia/acolhimentos"
            :servico_id="item.id"
        />
    </div>
</template>
<script>
import ModalRemanejarServico from "../../../../../resources/js/dashboard/components/widgets/ModalRemanejarServico";
import ModalAuditoria from "../../../../../resources/js/dashboard/components/widgets/ModalAuditoria";
import HistoricoStatus from "./HistoricoStatus";
export default {
    name: "Edit",
    components: {
        HistoricoStatus,
        ModalRemanejarServico,
        ModalAuditoria
    },
    data() {
        return {
            loading: true,
            item: {
                pessoas: [],
                familia: {
                    familiares: [],
                },
                user: {
                    tecnico: {}
                }
            },
            tecnicos: [],
            unidades: [],
            files: [],
            loadOutra: false,
            progressCompleted: 0,
            campoExtra: false,
            historicoStatus: false,
            statusAtual: "",
            statusAnterior: "",
            model: "Acolhimento",
        };
    },
    computed: {
        pessoas() {
            let pessoas = this.item.familia.familiares ?? [];
            pessoas = pessoas.filter((elem) => {
                return elem.estado_cadastral_cadunico <= 4;
            });
            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    elem.posicao_familiar == 1
                        ? "<b>RF - </b> " +
                          elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>"
                        : elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>",
            }));
            return map;
        },
        status_item() {
            const status = this.$root.arrays.status_acolhimento;
            const map = status.map((elem) => ({
                id: elem.id,
                descricao: elem.value,
            }));

            return map;
        },
    },
    mounted() {
        this.getUnidades();
        this.getItem();
    },
    methods: {
        getItem() {
            this.loading = true;
            axios
                .get(
                    `api/dashboard/familia/acolhimentos/` +
                        this.$route.params.id
                )
                .then((response) => {
                    this.item = response.data.data;
                    //console.log('item',this.item.user.tecnico.id);
                    this.statusAnterior = Number(this.item.status);
                    if (
                        this.item.outra_unidade != "" &&
                        this.item.unidade_acolhedora_id == ""
                    ) {
                        this.loadOutra = true;
                    }
                })
                .finally(() => (this.loading = false));
        },
        submitFile(files) {
            this.files = files;
        },
        getTecnicos(unidade_id) {
            this.loadUser = true;
            axios
                .get(`api/dashboard/tecnicos/get/externos/${unidade_id}`)
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => {
                    this.loadUser = false;
                });
        },
        getUnidades() {
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                    this.unidades.push({
                        id: this.unidades[this.unidades.length - 1]["id"] + 1,
                        value: "OUTRA",
                    });
                });
        },
        verificarStatus(status) {
            this.statusAtual = Number(status);

            const STATUS_INATIVO = 2;
            const STATUS_EGRESSO = 3;

            if (
                this.statusAtual !== Number(this.statusAnterior) &&
                [STATUS_INATIVO, STATUS_EGRESSO].includes(this.statusAtual)
            ) {
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
        submit() {
            this.item.familia_id = this.$route.query.familia_id;

            if (!this.item.data_inicial || this.item.data_inicial === '') {
                this.item.data_inicial = null;
            } else {
                const date = moment(this.item.data_inicial);
                this.item.data_inicial = date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : null;
            }

            if (!this.item.data_final || this.item.data_final === '') {
                this.item.data_final = null;
            } else {
                const date = moment(this.item.data_final);
                this.item.data_final = date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : null;
            }

            let formData = new FormData();

            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("anexos[]", this.files[i]);
                }
            } else {
                formData.append("anexos", this.files);
            }

            for (var key in this.item) {
                if (key != "pessoas") {
                    formData.append(key, this.item[key]);
                }
            }

            for (const i of Object.keys(this.item.pessoas)) {
                formData.append("pessoas[]", this.item.pessoas[i]);
            }

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(`api/dashboard/update/familia/acolhimento`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.getItem();
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
    },
};
</script>
